export default __webpack_public_path__ + "static/media/HP-Spectre-13-X360.28c3d951.jpg";